import React, { useEffect, useMemo, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Modal } from 'antd'
import { RankmiTable } from '@rankmi/rankmi-table'
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers'

import { headers } from './headers'
import { fetchSigners, selectAllSigners, selectSigners, selectSignersMeta, selectSignersStatus } from '@src/slices/signers.slice'
import { EnrollmentStatus, ISigner } from '@src/models'

interface IAddCounterpartsModal {
  open: boolean
  selectedSigners: ISigner[]
  onClose?: () => void
  onConfirm?: (users: ISigner[]) => void
  t: any
}

export const AddCounterpartsModal: React.FC<IAddCounterpartsModal> = ({
  open,
  selectedSigners,
  onClose,
  onConfirm,
  t
}) => {
  const dispatch = useDispatch()
  const [selectUsers, setSelectUsers] = useState<ISigner[]>(selectedSigners)
  const [selectedRows, setSelectedRows] = useState(
    selectedSigners?.map(({ token }) => token)
  )
  const [page, setPage] = useState<number>(1)
  const [terms, setTerms] = useState("")
  const meta = useSelector(selectSignersMeta)
  const users = useSelector(selectSigners)
  const status = useSelector(selectSignersStatus)
  const allSigners = useSelector(selectAllSigners)
  const loading = useMemo(() => status === 'loading', [status])


  const enrolledUsersOnly = useMemo(
    () =>
      users?.map((u) => ({
        ...u,
        disabled: !(
          u.enrolled && u.enrollment_status === EnrollmentStatus.Active
        )
      })),
    [users]
  )
  useEffect(() => {
    const q = {
      page,
      items: 10,
      terms
    } 
    dispatch(fetchSigners(q))
  }, [page, terms])

  const handleOk = () => {
    onConfirm?.(selectUsers)
  }

  const handleCancel = () => {
    onClose?.()
  }

  const handleSearch = (term: string) => {
    setTerms(term)
  }

  const handleOnSelected = ({ selectedRowKeys, dispatcher }: any): void => {
    if (dispatcher === 'onChange') {
      const findSigners = selectedRowKeys?.map((token: string) => allSigners.find(user => user.token === token))
      setSelectUsers(findSigners)
      setSelectedRows(selectedRowKeys)
    } else if (dispatcher === 'handleUnselectAllRows') {
      setSelectUsers([])
      setSelectedRows([])
    }
  }

  return (
    <Modal
      title={t('signature.newDocument.stepsForm.couterpartsInput.label')}
      visible={open}
      okText={t('signature.global.modalConfirm.okText')}
      cancelText={t('signature.global.modalConfirm.cancelText')}
      onOk={handleOk}
      onCancel={handleCancel}
      maskClosable={false}
    >
      <RankmiTable
        loading={loading}
        columnHeaders={headers(t)}
        data={enrolledUsersOnly}
        onSearch={handleSearch}
        selectedRows={selectedRows}
        locale={{
          header: {
            rowsCount: 'persona',
            rowsCount_plural: 'personas'
          }
        }}
        total={meta?.totalItems}
        currentPage={page}
        onPaginationChange={(nextPage: number) => {
          setPage(nextPage)
        }}
        countIcon={faUsers}
        onRowSelected={handleOnSelected}
        responsive
        showScrollButtons
      />
    </Modal>
  )
}
